import React, { FC, ReactNode } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, useTheme } from '@mui/material';
import chevron from '../../assets/images/icons/chevron-down.svg';

const SelectStyle = {
	border: '1px solid #969696',
	borderRadius: '5px',
	background: 'background: #FFFFFF',
	width: '100%',
	'& .MuiInputLabel-root': {
		color: '#707070'
	},
	'& .Mui-focused': {
		color: '#707070'
	},
	'& .MuiInputBase-root': {
		'& .MuiInputBase-input:focus': {
			border: 'none'
		}
	},
	marginTop: '20px'
};

const InputLabelStyle = {
	fontSize: '18px',
	color: '#707070'
};

export interface SelectOption {
	value: string;
	label: ReactNode;
}

interface StyledSelectProps {
	id: string;
	value: string;
	options: Array<SelectOption>;
	label: string;
	disabled?: boolean;
	onChange: (value: string) => void;
}

const ID_PREFIX = 'styled-select-label-';

export const StyledSelect: FC<StyledSelectProps> = React.memo(
	({ label, id, value, onChange, options, disabled = false }) => {
		const theme = useTheme();

		const handleChange = (event: SelectChangeEvent): void => {
			const value = event.target.value;
			onChange(value);
		};

		const style = {
			...SelectStyle,
			'&:focus-within': {
				border: `1px solid ${theme.palette.primary.main} !important`
			}
		};

		const labelId = `${ID_PREFIX}${id}`;
		return (
			<Box sx={{ width: '100%' }}>
				<FormControl
					variant="filled"
					fullWidth
					sx={style}
					className="controlled-input select-component"
					disabled={disabled}
				>
					<InputLabel style={InputLabelStyle} id={labelId}>
						{label}
					</InputLabel>
					<Select
						id={id}
						value={value || ''}
						label={label}
						labelId={labelId}
						onChange={handleChange}
						IconComponent={(props) => (
							<img src={chevron} alt="chevron" {...props} className={`chevron-icon ${props.className}`} />
						)}
					>
						{options.map((option, index) => (
							<MenuItem value={option.value} key={option.value}>
								{option.label}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Box>
		);
	}
);
